export type Gradient =
    'Brand Light' |
    'Brand Dark' |
    'Beach' |
    'Sunset' |
    'Northern Lights' |
    'Purple';

export class Gradients {
    public static readonly BRAND_LIGHT: Gradient = 'Brand Light';
    public static readonly BRAND_DARK: Gradient = 'Brand Dark';
    public static readonly BEACH: Gradient = 'Beach';
    public static readonly SUNSET: Gradient = 'Sunset';
    public static readonly NORTHERN_LIGHTS: Gradient = 'Northern Lights';
    public static readonly PURPLE: Gradient = 'Purple';
}

export const GradientClassMap: { gradient: Gradient, className: string }[] = [
    { gradient: Gradients.BRAND_LIGHT, className: 'gradient-brand-light' },
    { gradient: Gradients.BRAND_DARK, className: 'gradient-brand-dark' },
    { gradient: Gradients.BEACH, className: 'gradient-beach' },
    { gradient: Gradients.SUNSET, className: 'gradient-sunset' },
    { gradient: Gradients.NORTHERN_LIGHTS, className: 'gradient-northern-lights' },
    { gradient: Gradients.PURPLE, className: 'gradient-purple' }
];